import { render, staticRenderFns } from "./SwipeView.vue?vue&type=template&id=551b2ae9&scoped=true&"
var script = {}
import style0 from "./SwipeView.vue?vue&type=style&index=0&id=551b2ae9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b2ae9",
  null
  
)

export default component.exports